












































import { Vue, Component } from "@/shared/vuepack";
import * as RouteNames from "@/employer/route-names";
import { useDashboardStore } from "@/employer/store/dashboard";

const maxPercentage = 80;

@Component
export default class Enrollment extends Vue {
  dashboardStore = useDashboardStore();

  get totalAmount () { return this.dashboardStore.enrollment.total; }
  get enrolledAmount () { return this.dashboardStore.enrollment.enrolled; }
  get inProgressAmount () { return this.dashboardStore.enrollment.inProgress; }
  get notStartedAmount () { return this.dashboardStore.enrollment.notStarted; }

  get totalPercent () { return maxPercentage; }
  get enrolledPercent () { return Math.floor((this.enrolledAmount / this.totalAmount) * maxPercentage); }
  get inProgressPercent () { return Math.floor((this.inProgressAmount / this.totalAmount) * maxPercentage); }
  get notStartedPercent () { return Math.floor((this.notStartedAmount / this.totalAmount) * maxPercentage); }

  get manageRoute () { return {name: RouteNames.Employees}; }
  get showPendingInvites () { return !!this.dashboardStore.enrollment.pendingInvitations; }
  get numberOfPendingInvites () { return this.dashboardStore.enrollment.pendingInvitations; }
}
